import React, { Component } from "react";
import { Card, CardHeader, CardBody, Tooltip, Box } from '@chakra-ui/react';

import { AgGridReact } from "ag-grid-react";
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';

import _ from "lodash";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck, faCircleXmark } from "@fortawesome/free-solid-svg-icons";

import CoreService from "../../../../services/CoreService";
import NABCModal from "./nabcModal.jsx";



export default class NabcReplacementGrid extends Component {
    constructor(props) {
        super(props);
        this.state = {
            rowData: [],
            selectedRow: {},
            showNABCModal: false
        }
        this.coreService = new CoreService();
        this.onRowDoubleClicked = this.onRowDoubleClicked.bind(this);
        this.fetchNabcFilter = this.fetchNabcFilter.bind(this);

        this.onCloseModal = this.onCloseModal.bind(this);
        this.onSubmitNABCModal = this.onSubmitNABCModal.bind(this);
        this.gridOptions = {
            columnDefs: [
                { field: "propName", sortable: true, resizable: true },
                { field: "description", sortable: true, resizable: true },
                { field: "isPublic", sortable: true, resizable: true, cellRenderer: function (params) { return (params.value) ? <FontAwesomeIcon icon={faCircleCheck} color='green' /> : <FontAwesomeIcon icon={faCircleXmark} color='red' /> } },
                { field: "isReplaceable", sortable: true, resizable: true, cellRenderer: function (params) { return (params.value) ? <FontAwesomeIcon icon={faCircleCheck} color='green' /> : <FontAwesomeIcon icon={faCircleXmark} color='red' /> } },
                { field: "hasReplacement", sortable: true, resizable: true, cellRenderer: function (params) { return (params.value) ? <FontAwesomeIcon icon={faCircleCheck} color='green' /> : <FontAwesomeIcon icon={faCircleXmark} color='red' /> } },
                { field: "replacementValue", sortable: true, resizable: true, cellRenderer: function (params) { return (params.value) ? params.value : <FontAwesomeIcon icon={faCircleXmark} color='red' /> } },
            ]
        }
    }

    async componentDidMount() 
    {
        var newData = await this.fetchNabcFilter();
        this.setState({ rowData: newData });
        this.gridOptions.api.sizeColumnsToFit();

    }



    onRowDoubleClicked(row)
    {
        this.setState({selectedRow: row.data});
        if (!this.state.showNABCModal)
        {
            this.setState({showNABCModal: true});
        }
    }


    async fetchNabcFilter() {
        var filter = await this.coreService.fetchNabcFilter(this.props.filterType, this.props.userSession.token);
        return filter.dataResult.props;
    }

    onCloseModal() {
        this.setState({
            showNABCModal: false
        })
    }

    async onSubmitNABCModal(submittedData) 
    {
        this.setState({showNABCModal: false});
        var postData = _.cloneDeep(this.state.rowData);
        var propIdx = postData.findIndex(p=> p.propName === submittedData.propName);
        postData[propIdx].hasReplacement = submittedData.hasReplacement;
        postData[propIdx].replacementValue = submittedData.replacementValue;
        var replacementFilter = {
            "title": this.props.filterType,
            "props": postData
        }
        var updateResult =  await this.coreService.postNABCUpdateValueReplacementFilter(this.props.userSession.token, replacementFilter); 
        this.setState({rowData: replacementFilter.props}) 
        this.gridOptions.api.refreshCells();
    }

 

    render() {
        return (
            <Box m='1'>
                <NABCModal
                    title={this.props.title}
                    isOpen={this.state.showNABCModal}
                    onClose={this.onCloseModal}
                    data={this.state.selectedRow}
                    onSubmit={this.onSubmitNABCModal}
                />
                <Card
                    background='white'
                >
                    <CardHeader style={{ fontStyle: "italic", color: "#898787bd" }}>
                        {this.props.title}
                    </CardHeader>
                    <CardBody>
                        <Tooltip label='Double click to replace values' placement='top'>
                            <div className="ag-theme-alpine" style={{ height: 400, width: "100%" }}>
                                <AgGridReact
                                    rowData={this.state.rowData}
                                    // columnDefs={columnDefs}
                                    gridOptions={this.gridOptions}
                                    onRowDoubleClicked={(e) => this.onRowDoubleClicked(e)}
                                >
                                </AgGridReact>
                            </div>
                        </Tooltip>
                    </CardBody>
                </Card>
            </Box>
        )
    }
}